var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataManagementNewSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_811_7126)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6571 8.96514C14.7362 8.96514 18.0429 7.69055 18.0429 6.11828C18.0429 4.54601 14.7362 3.27142 10.6571 3.27142C6.57812 3.27142 3.27142 4.54601 3.27142 6.11828C3.27142 7.69055 6.57812 8.96514 10.6571 8.96514Z",
    stroke: "#643DD6",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0428 9.31447V6.11847",
    stroke: "#643DD6",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.27142 6.11847V15.1962C3.27142 16.6344 6.02202 17.7779 9.59749 18.0043",
    stroke: "#643DD6",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.27142 10.6572C3.27142 12.116 6.1659 13.3202 9.80475 13.4418",
    stroke: "#643DD6",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6597 11.3286V13.3428",
    stroke: "#643DD6",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5908 13.6786L14.3365 14.6857",
    stroke: "#643DD6",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5908 18.3785L14.3365 17.3714",
    stroke: "#643DD6",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6597 20.7286V18.7143",
    stroke: "#643DD6",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7286 18.3785L18.9828 17.3714",
    stroke: "#643DD6",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7286 13.6786L18.9828 14.6857",
    stroke: "#643DD6",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6597 18.7143C18.1429 18.7143 19.3454 17.5119 19.3454 16.0285C19.3454 14.5453 18.1429 13.3428 16.6597 13.3428C15.1764 13.3428 13.9739 14.5453 13.9739 16.0285C13.9739 17.5119 15.1764 18.7143 16.6597 18.7143Z",
    stroke: "#643DD6",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_811_7126"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataManagementNewSelected);
export default __webpack_public_path__ + "static/media/DataManagementNewSelected.efb14c1d9d75b50951465428d0a68f9a.svg";
export { ForwardRef as ReactComponent };